module.exports = __webpack_public_path__ + "img/region_arkansas_louisianna.0eb74387.svg";